module.exports = __webpack_public_path__ + "flyer_background_monsterra_070-8781406c6f91c7818d645edd6d24f756.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_monsterra_070.jpg
// module id = 1665
// module chunks = 1